<template>
    <div class="wrapper">
        <div class="columns">
            <div class="column is-9-widescreen is-9-fullhd is-9-tablet">
                <div class="m-b-40">
                    <back-button></back-button>
                    <div class="py-3">
                        <div class="dropdown" :class="{ 'is-active': dropdownActive }">
                            <div class="dropdown-trigger">
                                <input
                                type="text"
                                class="input input-search"
                                placeholder="Search"
                                v-model="searchQuery"
                                @focus="toggleDropdown(true)"
                                @blur="toggleDropdown(false)"
                                @input="onInput"
                                ref="inputSearch"
                                />
                            </div>
                            <!-- Dropdown Menu -->
                            <div class="dropdown-menu" role="menu">
                                <div class="dropdown-content">
                                <!-- Filtered Items -->
                                <a
                                    v-for="(item, index) in filteredItems"
                                    :key="index"
                                    class="dropdown-item"
                                    @mousedown.prevent="selectItem(item)"
                                >
                                    {{ item.title }}
                                </a>
                                <!-- No Items Found -->
                                <div v-if="filteredItems.length === 0" class="dropdown-item">
                                    No items found.
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="is-flex gap-20 is-flex-wrap-wrap">
                        <div>
                            <div class="mb-2" style="line-height:33px">Display only:</div>
                            <div class="mb-1"><b-checkbox v-model="filterHomepage" @change.native="filterFundNews"><span class="font-medium-mobile">Top news</span></b-checkbox></div>
                            <div class="mb-1"><b-checkbox v-model="filterTitle1" @change.native="filterFundNews"><span class="font-medium-mobile">News with Pickafund links</span></b-checkbox></div>
                            <div class="mb-1"><b-checkbox v-model="filterPartner" @change.native="filterFundNews"><span class="font-medium-mobile">News from partners</span></b-checkbox></div>                            
                            <button class="button btn-clear" :disabled="!filterHomepage && !filterTitle1 && !filterPartner" @click="filterHomepage=filterTitle1=filterPartner=false, filterFundNews()">CLEAR</button>
                        </div>
                        <div>
                            <div class="mb-2" style="line-height:33px">Filter by fund type:</div>
                            <div class="mb-1"><b-checkbox v-model="filterInvestment" @change.native="filterFundNews"><span class="font-medium-mobile">Investment trusts</span></b-checkbox></div>
                            <div class="mb-1"><b-checkbox v-model="filterETFs" @change.native="filterFundNews"><span class="font-medium-mobile">ETFs</span></b-checkbox></div>
                            <div class="mb-1"><b-checkbox v-model="filterOther" @change.native="filterFundNews"><span class="font-medium-mobile">Other</span></b-checkbox></div>
                            <button class="button btn-clear" :disabled="!filterInvestment && !filterETFs && !filterOther" @click="filterInvestment=filterETFs=filterOther=false, filterFundNews()">CLEAR</button>
                        </div>
                        <section class="platform-filter">
                            <b-dropdown
                                v-model="filterPlatformOptions"
                                multiple
                                ref="platformFilter"
                                aria-role="list"
                                class="mb-3"
                                position="is-bottom-left">
                                <template #trigger>
                                    <b-button
                                        type="is-primary"
                                        icon-right="menu-down"
                                        class="btn-platform">
                                        Filter by publication
                                    </b-button>
                                </template>
                                <b-dropdown-item @click="filterFundNews()" v-for="(item, index) in listFilter" :value="item" :key="item.id" aria-role="listitem" :class="index == listFilter.length -1 ? 'item-last': '' ">
                                    <span class="check"></span><span>{{item}}</span>
                                </b-dropdown-item>
                                <div class="dropdown-item-bottom">
                                    <b-icon
                                        class="scroll-down is-hidden-tablet"
                                        icon="chevron-double-down"
                                        size="is-small">
                                    </b-icon>
                                    <div class="p-b-1 dropdown-item-bottom-checkbox is-flex is-justify-content-space-between">
                                        <button class="button btn-clear" @click="filterPlatformOptions=[], filterFundNews()">CLEAR</button>
                                    </div>
                                </div>
                            </b-dropdown>
                            <b-dropdown
                                aria-role="list"
                                class="ml-0 mb-3"
                                position="is-bottom-left">
                                <template #trigger>
                                    <b-button
                                        type="is-primary"
                                        icon-right="menu-down"
                                        class="btn-platform">
                                        {{filterFund ? filterFund.FundBasicsName : 'Filter by fund'}}
                                    </b-button>
                                </template>
                                <b-dropdown-item @click="filterFund = filterFund === item ? null : item,filterFundNews()" v-for="(item, index) in listFilterFund" :value="item" :key="item.id" aria-role="listitem" :class="index == listFilter.length -1 ? 'item-last': '' ">
                                    <span class="check"></span><span>{{item.FundBasicsName}}</span>
                                </b-dropdown-item>
                                <div class="dropdown-item-bottom">
                                    <b-icon
                                        class="scroll-down is-hidden-tablet"
                                        icon="chevron-double-down"
                                        size="is-small">
                                    </b-icon>
                                    <b-dropdown-item @click="filterFund=null, filterFundNews()">
                                        <span class="button btn-clear mb-2">CLEAR</span>
                                    </b-dropdown-item>
                                </div>
                            </b-dropdown>
                            <b-dropdown
                                aria-role="list"
                                class="ml-0 mb-3"
                                position="is-bottom-left">
                                <template #trigger>
                                    <b-button
                                        type="is-primary"
                                        icon-right="menu-down"
                                        class="btn-platform">
                                        {{filterCategory ? filterCategory.category_name : 'Filter by fund category'}}
                                    </b-button>
                                </template>
                                <b-dropdown-item @click="filterCategory = filterCategory === item ? null : item,filterFundNews()" v-for="(item, index) in listFilterCategory" :value="item" :key="item.id" aria-role="listitem" :class="index == listFilter.length -1 ? 'item-last': '' ">
                                    <span class="check"></span><span>{{item.category_name}}</span>
                                </b-dropdown-item>
                                <b-dropdown-item v-if="!listFilterCategory.length">No filter data</b-dropdown-item>
                                <div class="dropdown-item-bottom">
                                    <b-icon
                                        class="scroll-down is-hidden-tablet"
                                        icon="chevron-double-down"
                                        size="is-small">
                                    </b-icon>
                                    <b-dropdown-item @click="filterCategory=null, filterFundNews()">
                                        <span class="button btn-clear mb-2">CLEAR</span>
                                    </b-dropdown-item>
                                </div>
                            </b-dropdown>
                        </section>
                    </div>
                    
                    <div class="columns is-flex is-flex-direction-column">
                        <div class="column">
                            <div class="mt-5">
                                <h1 class="title-page is-size-5 is-size-4-desktop has-text-weight-bold mr-5 m-b-20">UK fund news recap</h1>
                                <p>Here is our selection of articles regarding investment funds for UK retail investors</p>
                            </div>
                        </div>
                        <div class="column is-6-mobile ml-3 list-news">
                            <div class="is-flex mb-5 news-item" :id="'new-' + news.id" :class="news.partner ? 'news-partner' : ''" v-for="news in fundNews" :key="news.id">
                                <div class="mr-5 news-date-desktop"><strong>{{ getNewsDate(news) }}</strong></div>
                                <div class="is-flex is-flex-direction-column news">
                                    <a class="mb-1 news-title" :href="news.url" v-on:click="countStats(news.id)" target="_blank">{{ news.title }}</a>
                                    <div class="mb-2 news-date-mobile">
                                        {{ getNewsDate(news, 'DD-MMM-YY') }} | {{ news.site }}
                                    </div>
                                    <div class="mb-2 news-date-desktop">({{ news.site }})</div>

                                    <div v-show="news.summary" class="news-summary">{{ news.summary }}</div>
                                    <ul class="news-subitems">
                                        <li v-for="n in 4" :key="n" class="news-subitem" v-show="news[`title${n}`]">
                                            <span class="right-arrow-icon">➤</span>
                                            <a :href="news[`url${n}`]" target="_blank">{{ news[`title${n}`] }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <button id="scrollToAlertBtn" class="is-hidden" v-scroll-to="'#myAlerts'">
                            Scroll to #element
                        </button>
                    </div>
                </div>
            </div>
            <div ref="subRight_before" class="column is-12-mobile is-3-tablet is-3-widescreen banner-right is-3-fullhd">
                <div class="banner-on-top" ref="subRight">
                    <AdsGoogle />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BackButton from '@/components/BackButton.vue';
import axios from 'axios';
import moment from 'moment';
import bannerMixin from "@/mixins/bannerMixin";
import commonMixin from "@/mixins/commonMixin";
import AdsGoogle from '@/components/AdsGoogle.vue';
export default {
    name: "FundNewsRecap",
    components: { BackButton, AdsGoogle },
    mixins:[bannerMixin, commonMixin],
    metaInfo() {
        return {
            title: "Fund news recap | Pickafund",
            meta: [
                {
                    name: "description",
                    content:
                        "See our news selection for UK investment funds",
                },
                { property: "og:title", content: "Fund news recap | Pickafund" },
            ],
        };
    },
    data() {
        return {
            filterHomepage: false,
            filterPartner: false,
            filterTitle1: false,
            filterOther: false,
            filterInvestment: false,
            filterETFs: false,
            fundNews: null,
            filteredItems: [],
            dropdownActive: false,
            filterPlatformOptions: [],
            listFilter: [],
            listFilterFund: [],
            listFilterCategory: [],
            filterCategory: null,
            filterFund: null
        }
    },
    methods: {
        filterFundNews() {
            const urlGetFundNews = `/newslists/date/-1`;
            let bodykeywords = [];
            if (this.filterETFs) {
                bodykeywords.push("etf")
            }
            if (this.filterInvestment) {
                bodykeywords.push("investment trust")
            }
            let params = {
                bodykeywords,
                "site" : this.filterPlatformOptions
            };
            this.filterHomepage && (params['homepage'] = this.filterHomepage);
            this.filterTitle1 && (params['title1'] = this.filterTitle1);
            this.filterPartner && (params['partner'] = this.filterPartner);
            this.filterOther && (params['other'] = this.filterOther);
            this.filterFund && (params['related_isin'] = this.filterFund.ISIN);
            this.filterCategory && (params['replace_category'] = this.filterCategory.mscategoryid);
            axios.post(urlGetFundNews, params).then(response => {
                if (response)
                    this.fundNews = response.data
            })
        },
        getListFilter() {
            axios.get('/list-publication').then(response => {
                if (response)
                    this.listFilter = response.data.sort((a, b) => a.localeCompare(b))
            })
            axios.get('/funddropdown').then(response => {
                if (response)
                    this.listFilterFund = response.data.sort((a, b) => a.FundBasicsName.localeCompare(b.FundBasicsName))
            })
            axios.get('/categorydropdown').then(response => {
                if (response)
                    this.listFilterCategory = response.data.sort((a, b) => a.category_name.localeCompare(b.category_name))
            })
        },
        getFundNews() {
            const urlGetFundNews = `/newslists/date/-1`;
            axios.post(urlGetFundNews).then(response => {
                if (response)
                    this.fundNews = response.data
            })
        },
        getNewsDate(news, format = 'MM/DD/yyyy') {
            const { date, created_at } = news;
            return date ? moment(date).format(format) : moment(created_at).format(format);
        },
        countStats(news_id){
            axios.post("/fundnewsrecapstats/" + news_id);
        },
        toggleDropdown(state) {
            this.dropdownActive = state;
        },
        onInput() {
            const query = this.searchQuery.toLowerCase().trim();
            if (query == '') {
                this.filteredItems = [];
            } else {
                this.filteredItems = this.fundNews.sort((a, b) => 
                    a.title.localeCompare(b.title)).filter((news) =>
                        query.split(/\s+/).every(keyword => news.title.toLowerCase().includes(keyword.toLowerCase()))
                );
            }
            if (!this.dropdownActive) this.toggleDropdown(true);
        },
        selectItem(item) {
            this.filteredItems = [];
            this.searchQuery = '';
            this.$refs.inputSearch.blur();
            const element = document.getElementById("new-" + item.id);
            const headerHeight = document.querySelector(".navbar").offsetHeight;
            if (element) {
                window.scrollTo({ top: element.getBoundingClientRect().top - headerHeight, behavior: "smooth" });
            }
        }
    },
    computed: {
       
    },
    created() {
        this.getListFilter();
        this.getFundNews();
        window.addEventListener('scroll', this.handleScroll);
    }
};
</script>
<style scoped lang="scss">
    .platform-filter {
        display: flex;
        flex-direction: column;   
    }
    .platform-filter .btn-platform {
        width: 200px;
    }
    .platform-filter .dropdown-menu .dropdown-content .dropdown-item {
        color: #153647;
        gap: 10px;
    }
    .platform-filter .dropdown-menu .dropdown-content .dropdown-item:hover {
        background: #41bcea;
        color: #fff;
    }
    .gap-20 {
        gap: 20px;
    }
    .news {
        &-title {
            font-weight: bold;
            font-size: 20px;
            text-decoration: underline;
        }
        &-summary {
            font-size: 16px;
            font-weight: 500;
            padding-bottom: 5px;
        }
        &-subitems {
            display: flex;
            flex-direction: column;
            gap: 3px;
        }
        &-subitem {
            display: flex;
            gap: 20px;
            font-size: 16px;
            a {
                text-decoration: underline;
            }
        }
    }
    .right-arrow-icon {
        font-size: 20px;
    }
    .news {
        width: 100%;

        &-date, &-source {
            &-desktop {
                display: block;
            }
            &-mobile {
                display: none;
            }
        }
    }
    @media (max-width: 767px) {
        .news {
            &-date, &-source {
                &-desktop {
                    display: none;
                }
                &-mobile {
                    display: block;
                    text-wrap: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }
        .list-news {
            margin-left: 0 !important;
            width: 100%;
        }
    }
    .news-item {
        padding: 10px;
    }
    .news-partner {
        background: #b9ede8;
    }
    .input-search {
        background-image: url(/img/search-icon.png);
        background-position: 8px center;
        background-repeat: no-repeat;
        padding-left: 1.75em;
        background-size: 21px;
    }
    .dropdown-menu .dropdown-content .dropdown-item {
        color: #009BDE;
        gap: 0;
    }
    .dropdown-menu .dropdown-content .dropdown-item {

    }
    .dropdown-menu .dropdown-content .dropdown-item:hover {
        background-color: #eee;
    }
    .dropdown-menu .dropdown-content {
        box-shadow: 0 0.5em 1em 0.25em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02)
    }
    .dropdown-menu {
        overflow: auto;
        max-height: 400px;
    }
    ::v-deep .btn-platform span:first-child {
        overflow: hidden;
        margin-right: 15px;
    }
    .dropdown-item-bottom .dropdown-item {
        background: transparent !important;
    }
</style>
